import { createFeatureSelector, createSelector } from '@ngrx/store';

import { driversAdapter, DriversState } from '@store/drivers/drivers.state';
import { selectAllDriversGroups } from '@store/driversGroups/driversGroups.selectors';

export const selectDriversNotGroupById = (state: any, driversIds: number[]) => {
  return state.drivers.list.filter((f: any) => !driversIds.includes(f.id));
};

// -------------------------------------------------------------
export const selectDriversState = createFeatureSelector<DriversState>('drivers');

const { selectAll, selectEntities, selectIds } = driversAdapter.getSelectors(selectDriversState);
export const selectAllDrivers = selectAll;
export const selectDriversEntities = selectEntities;
export const selectDriversIds = selectIds;
export const selectLoadingDriversList = createSelector(
  selectDriversState,
  (state) => state.loading,
);

export const selectLastStateDriversPage = createSelector(
  selectDriversState,
  (state) => state.lastPageState,
);
export const selectLastStateOnTabDriversList = createSelector(
  selectDriversState,
  (state) => state.lastPageState.list,
);

export const selectLastStateOnTabDriversGroups = createSelector(
  selectDriversState,
  (state) => state.lastPageState.groups,
);

export const selectDriverById = (id: string | number) =>
  createSelector(selectDriversEntities, (entities) => entities[id]);

export const selectDriversByIds = (ids: (string | number)[]) =>
  createSelector(selectDriversEntities, (entities) =>
    ids.map((id) => entities[id]).filter(Boolean),
  );

export const selectUngroupedDrivers = createSelector(
  selectAllDrivers,
  selectAllDriversGroups,
  (drivers, groups) => {
    // Собираем все ID прицепов, которые входят в группы
    const groupedDriversIds = new Set(groups.flatMap((group) => group.tiedDrivers ?? []));

    // Возвращаем прицепы, которых нет в группах
    return drivers.filter((trailer) => !groupedDriversIds.has(trailer.id));
  },
);

export const selectDriversByObjectId = (objectId: number) =>
  createSelector(selectAllDrivers, (drivers) =>
    drivers.filter((driver) => driver.object?.id === objectId),
  );
